import { I18n } from '@tcc/i18n';

const i18n = new I18n();

/**
 * Add messages to the i18n instance
 * Wrapper for addMessages
 * @param {Object} newMessages
 * @return {undefined}
 */
export const addMessages = newMessages => { i18n.addMessages(newMessages); };

/**
 * Gets language from the i18n instance
 * @return {String}
 */
export const getLanguage = () => i18n.language;

/**
 * Gets locale from the i18n instance
 * @return {String}
 */
export const getLocale = () => i18n.locale;

/**
 * Gets translated string using an id
 * Wrapper for getMessage when data is undefined
 * Wrapper for getFormattedMessage when data is defined
 * @param {String} messageId
 * @param {Object} [data]
 * @return {String}
 */
export const getMessage = (messageId, data) => {
  return data === undefined
    ? i18n.getMessage(messageId) : i18n.getFormattedMessage(messageId, data);
};
